// eslint-disable-next-line no-restricted-imports
import styled from 'styled-components';
import { devices } from 'utils/styledHelpers';

export const FaqSection = styled.div`
  /* align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 80px 0 80px 0;
  width: 100%; */
  background: rgba(243, 243, 252, 0.5);
  /* ${devices.medium} {
    padding: 64px 0 64px 0;
  }

  ${devices.small} {
    padding: 64px 0 64px 0;
  }

  ${devices.xsmall} {
    padding: 64px 0 64px 0;
  } */

  border-radius: 16px;
  box-sizing: border-box;
  gap: 40px;
  padding: 80px 180px;
  width: 100%;

  ${devices.medium} {
    padding: 80px 48px;
  }

  ${devices.mobile} {
    padding: 80px 16px;
  }

  .content-info {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .category {
      color: #7da2ff;
      font-size: 20px;
      font-weight: 700;
      line-height: 30px;
      margin-bottom: 20px;
      text-align: left;
    }

    .description {
      color: #312f4f;
      font-size: 20px;
      font-weight: 400;
      line-height: 30px;
      margin-bottom: 50px;
      margin-top: 20px;
      text-align: left;
    }

    h2 {
      color: #312f4f;
      font-size: 32px;
      font-weight: 700;
      line-height: 120%;
      text-align: center;
    }
  }

  .faq-container {
    margin-top: 40px;
    max-width: 100%;
    .faq-item {
      background-color: #ffffff;
      border: 1px solid #f3f3fc;
      height: fit-content;
      margin-bottom: 10px;
      width: auto;
      .faq-answer {
        ul {
          margin-left: 20px;
          width: fit-content;

          li {
            font-size: 16px;
            line-height: 150%;
            list-style: disc;
            list-style-type: disc;
            width: fit-content;
          }
        }
      }
    }
  }
`;
